import api from "@/config/apiConfig"

class SettingsController {
  async index() {
    try {
      const response = await api.get("/settings")
      return response.data
    } catch (error) {
      console.error("Erro no SettingsController.index: ", error)
      throw error
    }
  }

  async getByKey(key) {
    try {
      const response = await api.get(`/settings/key/${key}`)
      return response.data
    } catch (error) {
      console.error("Erro no SettingsController.getByKey: ", error)
      throw error
    }
  }

  async update(id, data) {
    try {
      const response = await api.patch(`/settings/${id}`, data)
      return response.data
    } catch (error) {
      console.error("Erro no SettingsController.update: ", error)
      throw error
    }
  }

  async create(data) {
    try {
      const response = await api.post("/settings", data)
      return response.data
    } catch (error) {
      console.error("Erro no SettingsController.create: ", error)
      throw error
    }
  }
}

export default new SettingsController();
